import React from 'react';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';

import { ReactComponent as InfoIcon } from "../../../../assets/images/rest_info.svg";

const ToggleSwitchLabel = ({ label, info, styles }) => {
  return (
    <Typography
      className={`${styles?.["toggle-switch-label"]}`}
      sx={{ path: { fill: "#000" }, mr: 1 }}
    >
      {label}
      {info ? (
        <Tooltip
          componentsProps={{
            tooltip: {
              sx: {
                marginTop: "0px !important",
                marginBottom: "0px !important",
                backgroundColor: "#EEE",
                color: "#000",
              },
            },
          }}
          title={info}
          placement="top"
        >
          <InfoIcon
            height={15}
            width={15}
            style={{ cursor: "pointer", marginLeft: 4 }}
          />
        </Tooltip>
      ) : null}
    </Typography>
  );
};
export default ToggleSwitchLabel;
